// import { Button, Form } from 'antd';
// import { Grid } from '@mui/material';
// import { useEffect, useState } from 'react';
// import pdfIcon from 'assets/images/icons/pdf_red.svg';
// import pdfIconDisable from 'assets/images/icons/pdf_white.svg';
// import CardAccordion from 'components/CardAccordion/CardAccordion';
// import CustomAccordion from '../../../lease-record-management-v6/CustomComponents/LeaseUtils/CustomAccordion';
// import GrossRentHistory from '../../../lease-v9/lease-record-management-v9/CustomComponents/LeaseUtils/History/GrossRentHistory';

// const LeaseRecordManagementV9ModifyHistory = ({ viewData, selectHistory }) => {
// 	const form = Form.useFormInstance();
// 	const [listLength, setListLength] = useState(0);

// 	const grossRentListSet = form.getFieldValue('grossRentListSet');

// 	useEffect(() => {
// 		setListLength(grossRentListSet?.length || 0);
// 	}, [grossRentListSet]);

// 	// const advanceAmountListSet = form.getFieldValue('advanceAmountListSet');

// 	return (
// 		<>
// 			<CustomAccordion
// 				title="Lease Payment Schedule"
// 				customHeaderSX={{
// 					backgroundColor: '#e1f0ff !important',
// 					p: '10px',
// 				}}
// 				typographySX={{ fontSize: '16px !important' }}
// 				darkTitle={true}
// 				sx={{ mb: 2 }}
// 			>
// 				<Grid container spacing={3} sx={{ p: 2 }}>
// 					{grossRentListSet?.map((item, index) => (
// 						// 2. Each item is a Grid item. On large screens (lg), they take 6 of 12 columns (i.e., 50% width).
// 						// On smaller screens, they take 12 of 12 columns (100% width), stacking automatically.
// 						<Grid
// 							item
// 							xs={12}
// 							lg={
// 								index === 0 && listLength !== 2
// 									? 12
// 									: index === 0 && listLength === 2
// 										? 6
// 										: listLength > 2 && listLength % 2 === 0 && index === listLength - 1
// 											? 12
// 											: 6
// 							}
// 							key={index}
// 						>
// 							<GrossRentHistory data={item} index={index} otherChanges={viewData?.data?.changes[index]} />
// 						</Grid>
// 					))}
// 				</Grid>
// 			</CustomAccordion>

// 			<CardAccordion
// 				title="Other Changes History"
// 				customHeaderSX={{
// 					backgroundColor: '#e1f0ff !important',
// 					p: '10px',
// 				}}
// 				typographySX={{ fontSize: '16px !important' }}
// 				darkTitle={true}
// 				sx={{ mb: 2 }}
// 			>
// 				<Button
// 					type="primary"
// 					style={{
// 						fontSize: '13px',
// 						fontWeight: '500',
// 						borderRadius: '6px',
// 						marginRight: '3px',
// 						display: 'flex',
// 						alignItems: 'center',
// 						gap: '6px',
// 						...(viewData?.history?.length === 0 ? { backgroundColor: '#6c757d' } : {}),
// 					}}
// 					onClick={(e) => {
// 						e.stopPropagation();
// 						if (selectHistory) {
// 							selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
// 						} else if (viewData?.selectHistory) {
// 							viewData.selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
// 						}
// 					}}
// 				>
// 					<img src={viewData?.history?.length > 1 ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
// 					Log
// 				</Button>
// 			</CardAccordion>
// 		</>
// 	);
// };

// export default LeaseRecordManagementV9ModifyHistory;

import dayjs from 'dayjs';
import { Form } from 'antd';
import { Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import SectionCard from 'components/section/SectionCard';
import DataTableV8 from 'components/LynDataTable/DataTableV8';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import LeaseHistoryDetailModal from '../details/LeaseHistoryDetailModal';

const LeaseRecordManagementV9HistoryTable = () => {
	const form = Form.useFormInstance();

	const leaseId = form.getFieldValue('leaseId');

	const [showModal, setShowModal] = useState(false);
	const [detailType, setDetailType] = useState(null);
	const [selectHistory, setSelectHistory] = useState(null);
	const [paginationModify, setPaginationModify] = useState({
		pageIndex: 0,
		pageSize: 15,
	});
	const [paginationEdit, setPaginationEdit] = useState({
		pageIndex: 0,
		pageSize: 15,
	});

	const [getLeaseHistoryData, { data: leaseHistoryData, isLoading: isLeaseHistoryDataLoading }] = useSendControlDataMutation();

	const COLUMNS = useMemo(
		() => [
			{
				header: 'Effective Date',
				key: 'inputChangeEffectiveDate',
				accessorFn: (row) => {
					const effectiveDate = row?.[1]?.changes?.[row?.[1]?.changes?.length - 1]?.inputChangeEffectiveDate;

					return effectiveDate ? dayjs(effectiveDate).format('YYYY-MM-DD') : 'N/A';
				},
			},
			{
				key: 'leaseTerm',
				header: 'Lease Term',
				accessorFn: (row) => row?.[1]?.leaseTerm || 'N/A',
			},
			{
				key: 'paymentModality',
				header: 'Payment Modality',
				accessorFn: (row) => {
					const value = row?.[1]?.paymentModality;

					return value === 'Start' ? 'Advance Basis' : 'Accrual Basis';
				},
			},
			{
				key: 'paymentFrequency',
				header: 'Payment Frequency',
				accessorFn: (row) => row?.[1]?.paymentFrequency || 'N/A',
			},
			{
				header: 'IBR',
				key: 'initialDiscountRate',
				accessorFn: (row) => row?.[1]?.initialDiscountRate || 'N/A',
			},
			{
				key: 'leaseStartDate',
				header: 'Lease Start Date',
				accessorFn: (row) => {
					const startDate = row?.[1]?.leaseStartDate;

					return startDate ? dayjs(startDate).format('YYYY-MM-DD') : 'N/A';
				},
			},
			{
				key: 'leaseEndDate',
				header: 'Lease End Date',
				accessorFn: (row) => {
					const endDate = row?.[1]?.leaseEndDate;

					return endDate ? dayjs(endDate).format('YYYY-MM-DD') : 'N/A';
				},
			},
		],
		[]
	);

	useEffect(() => {
		if (leaseId) {
			const payload = { leaseId };
			const convertBase64 = btoa(JSON.stringify(payload));

			getLeaseHistoryData({
				payload,
				data: convertBase64,
				processCode: '10147',
				scriptName: 'lease-edit-modify-history',
			});
		}
	}, [leaseId]);

	const modifiedData = leaseHistoryData?.responseData?.modifiedData || [];
	const editData = leaseHistoryData?.responseData?.editedData || [];
	const sectionTitleSx = {
		color: '#344054',
		padding: '0 0 12px 0',
		fontWeight: 600,
		fontSize: '18px',
		borderBottom: '1px solid #eaeef4',
		marginBottom: '16px',
	};
	const detailSectionCardSx = {
		padding: '16px',
		marginBottom: '24px',
		borderRadius: '10px',
		border: '1px solid #e6ebf2',
	};

	return (
		<>
			<SectionCard sx={detailSectionCardSx}>
				<Typography variant="h4" sx={sectionTitleSx}>
					Modify History
				</Typography>

				<DataTableV8
					manualPagination
					COLUMNS={COLUMNS}
					DATA={modifiedData}
					firstColStrick={false}
					pagination={paginationModify}
					totalCount={modifiedData.length}
					isLoading={isLeaseHistoryDataLoading}
					xlsxFileName={`${leaseId}_modifiedData`}
					onPaginationChange={setPaginationModify}
					onClickHandler={(data) => {
						setShowModal(true);
						setSelectHistory(data);
						setDetailType('modify');
					}}
				/>
			</SectionCard>

			<SectionCard sx={detailSectionCardSx}>
				<Typography variant="h4" sx={sectionTitleSx}>
					Edit History
				</Typography>

				<DataTableV8
					DATA={editData}
					manualPagination
					COLUMNS={COLUMNS}
					firstColStrick={false}
					pagination={paginationEdit}
					totalCount={editData.length}
					xlsxFileName={`${leaseId}_editData`}
					isLoading={isLeaseHistoryDataLoading}
					onPaginationChange={setPaginationEdit}
					onClickHandler={(data) => {
						setShowModal(true);
						setDetailType('edit');
						setSelectHistory(data);
					}}
				/>
			</SectionCard>

			{showModal && (
				<LeaseHistoryDetailModal
					showModal={showModal}
					detailType={detailType}
					setShowModal={setShowModal}
					setDetailType={setDetailType}
					selectHistory={selectHistory}
					setSelectHistory={setSelectHistory}
				/>
			)}
		</>
	);
};

export default LeaseRecordManagementV9HistoryTable;
